import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import bruttoProduction from 'features/views/bruttoProduction';

import BruttoProductionTable from './components/BruttoProductionTable';

const BruttoProductionModalBody = ({ contact }) => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(bruttoProduction.actions.loadBruttoProduction(contact));
	}, [dispatch, contact]);

	return <BruttoProductionTable />;
};

BruttoProductionModalBody.propTypes = {
	contact: PropTypes.object,
};

export default BruttoProductionModalBody;
